import { EAgentName, EChatbotVariant } from '@/components/chatbot/ChatbotProvider';

export enum EChatbotEventName {
  CHATBOT_NEW_CONVERSATION_STARTED = 'Chatbot New Conversation Started',
  CHATBOT_OPENED = 'Chatbot Opened',
  CHATBOT_CLOSED = 'Chatbot Closed',
  CHATBOT_RESET_CHAT = 'Chatbot Reset Chat',
  CHATBOT_TRIP_PLANNER_RENTAL_SEARCH = 'Chatbot Trip Planner Rental Search Results Displayed',
  CHATBOT_SHOW_MORE_CLICKED = 'Chatbot Show More Clicked',
  CHATBOT_REFINE_SEARCH_CLICKED = 'Chatbot Refine Search Clicked',
  CHATBOT_ERROR = 'Chatbot Error',
}

export interface IChatbotEvent {
  agentName: EAgentName;
  variant: EChatbotVariant;
  messageCount?: number;
  sessionId?: string;
}

export interface IChatbotRentalSearchEvent extends IChatbotEvent {
  queryParams?: string;
  tripName?: string;
  tileCount?: number;
  messageCount?: number;
}

export interface IChatbotErrorEvent extends IChatbotEvent {
  error?: string;
}
